import React from "react";
import { Routes, Route } from "react-router-dom";
import ViewsDashboard from "./ViewsDashboard";
import ViewRenderer from "./ViewRenderer";

const ViewsDashboardWrapper = () => {
  return (
    <Routes>
      <Route index element={<ViewsDashboard />} />
      <Route path=":viewGuid/*" element={<ViewRenderer />} />
    </Routes>
  );
};

export default ViewsDashboardWrapper;
